export default __webpack_public_path__ + "static/refrigerator_deluxe_bold-fc451348b46a0ab0028fb43399e315df.otf";